// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".align-right[data-v-6dd7b956] {\n  text-align: right;\n}\n@media (max-width: 700px) {\n.align-right[data-v-6dd7b956] {\n      text-align: left;\n}\n}\n.name[data-v-6dd7b956] {\n  min-width: 115px;\n}\na[data-v-6dd7b956] {\n  word-break: break-word;\n}\n", ""]);
// Exports
module.exports = exports;
